import { useEffect, useState } from "react"
import { ajax } from "../../scripts/helper"
import utils from "../../scripts/utils"
import { useSnackbar } from 'notistack'
import { useNavigate } from "react-router-dom"



const IbanInquiry = ({data, id}) => {
    const { enqueueSnackbar } = useSnackbar()
    const navigate = useNavigate()


    const blockPayment = async()=>{
        const res = await ajax({
            method:"GET",
            url: utils.urls.transactionBlock(id),
            hasToken: true,
            snackbar: enqueueSnackbar
        })
        if(!res) return
        navigate("/agent/payments")
    }
    return(
        <>
            <div className="link-detail">
                <div className="link-value-label">
                    <label>Iban</label>
                </div>
                <div className="link-amount">
                    <p className="p2">{data.iban}</p>
                    {/* <p className="p1">{(response && response.currency ? response.currency.code : '')}</p> */}
                    
                </div>
                <div className="link-row">
                    <div className="link-first">
                        <label>Account Owner</label>
                        <span>{data.accountOwner}</span>
                    </div>
                    <div className="link-second">
                        <label>Account number</label>
                        <span>{data.iban}</span>
                    </div>
                </div>
                <div className="link-row">
                    <div className="link-first"> 
                        <label>Account Status</label>
                        <span>{(data.accountStatus === 'ACTIVE' ? 'فعال': 'غیرفعال')}</span>
                    </div>
                    <div className="link-second">
                        <label>Comment</label>
                        <span>{data.comments}</span>
                    </div>
                </div>
                {/* <div className="link-row">
                    <div className="link-first">
                        <label>Product</label>
                        <span>{(response && response.product ? response.product.name : '')}</span>
                    </div>
                </div> */}
            </div>
            <div className="send-btn-container">
                <button className="back" onClick={() => blockPayment()} style={{'marginTop': '0px'}}>Reject</button>
                <button className="send" onClick={() => navigate('/agent/payments', {replace: true})}>Confirm</button>
            </div>
        </>
        
    )
}

export default IbanInquiry